import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { EnumValue } from "lib/generated/integration-api";
import { useIntegrationApi } from "lib/integrationApiContext";

type QueryKey = [string, string, Record<string, string>, string | undefined];

/**
 * Loads a picklist's values from the CRM. `entityName` names the object the property belongs to;
 * a native install's server-built form leaves it out because the service reads it from the stored
 * config, while a Paragon-backed form has to say.
 */
export function usePropertyOptions(
  propertyName: string,
  formData: Record<string, string>,
  entityName?: string,
  options?: UseQueryOptions<EnumValue[], unknown, EnumValue[], QueryKey>,
) {
  const api = useIntegrationApi();
  return useQuery(
    ["fetchPropertyValues", propertyName, formData, entityName],
    async () => {
      const response = await api.fetchPropertyValues({
        fetchPropertyValuesRequest: { propertyName, formData, entityName },
      });
      return response.values;
    },
    options,
  );
}
